var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ed-section-folder-icon"},[_c('ed-icon',{staticClass:"ed-icon-folder",attrs:{"icon":_vm.icon}}),_c('span',{class:_vm.circleClass},[_c('ed-icon',{staticClass:"ed-icon-state",attrs:{"icon":_vm.folderIconCircle}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }